(function($) {
/*  $(document).ready(function() {
    // removes all note links within notes (in accordion)
    $('.accordion__content').find('span.note').each(function(){
      var text = $(this).text();
      $(this).removeClass('note');
      $(this).empty();
      $(this).text(text);
    });
  });*/
})(jQuery);